<template>
    <div class="toaster">

        <div class="toaster__header">
            <h2> {{ thisTitle }} </h2>
        </div>

        <div class="toaster__body">
            <slot></slot>
        </div>
    
    </div>
</template>

<script>


export default {
    name: "toaster",
    props: {heading:""},

    data () {
        return {
            thisTitle: this.heading,
           
        }
    },

    methods: {
       
    }

    
}
</script>